<template>
  <div id="showInfo">
  <home-header></home-header>
  	<div class="bodyer">
  		<div id="showContent" v-html="contentData"></div>
  	</div>
  </div>
</template>

<script>
import axios from 'axios'
import HomeHeader from './header'
export default {
	name:'showInfo',
	components:{
  	  HomeHeader:HomeHeader
  	},
	data:function(){
		return {
			gcmsid:"",
			gcmsname:"",
			contentData:""
		}
	},
	methods:{
		getInfoData:function(){
			axios.get('http://202.107.245.49:5500/content/'+this.gcmsname+'/'+this.gcmsid)
  				.then(this.updateData)
		},
		updateData:function(res){
			this.contentData = res.data.data.content;
		}
	},
  	mounted:function(){
  		this.gcmsid = this.$route.query.gcmsid;
		this.gcmsname = this.$route.query.gcmsname;
		this.getInfoData();
  	}
}
</script>
<style scoped>
	
</style>




// WEBPACK FOOTER //
// src/pages/components/showInfo.vue